var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 28.375H48.0625V49C48.0625 50.6569 46.7194 52 45.0625 52H27.4375C25.7806 52 24.4375 50.6569 24.4375 49V28.375Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3281 34.2812C31.8718 34.2812 32.3125 34.8689 32.3125 35.5938V44.7812C32.3125 45.5061 31.8718 46.0938 31.3281 46.0938C30.7845 46.0938 30.3438 45.5061 30.3438 44.7812V35.5938C30.3438 34.8689 30.7845 34.2812 31.3281 34.2812Z",
    fill: "#FECDCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1719 34.2812C41.7155 34.2812 42.1562 34.8689 42.1562 35.5938V44.7812C42.1562 45.5061 41.7155 46.0938 41.1719 46.0938C40.6282 46.0938 40.1875 45.5061 40.1875 44.7812V35.5938C40.1875 34.8689 40.6282 34.2812 41.1719 34.2812Z",
    fill: "#FECDCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.375 25.225C28.375 22.6155 30.4905 20.5 33.1 20.5H39.4C42.0095 20.5 44.125 22.6155 44.125 25.225H50.425C51.2948 25.225 52 25.9302 52 26.8C52 27.6698 51.2948 28.375 50.425 28.375H22.075C21.2052 28.375 20.5 27.6698 20.5 26.8C20.5 25.9302 21.2052 25.225 22.075 25.225H28.375ZM33.1 23.65H39.4C40.2698 23.65 40.975 24.3552 40.975 25.225H31.525C31.525 24.3552 32.2302 23.65 33.1 23.65Z",
    fill: "#FECDCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBig);
export default __webpack_public_path__ + "static/media/DeleteBig.93f0eaf49bcc396ed8a71902f76ad048.svg";
export { ForwardRef as ReactComponent };